<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <div>
        <!-- ボタン -->
        <t-row>
          <t-col :span="8" class="col_common_center">
            <!-- 新規 -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick()"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.sys.newBuilt") }}
            </t-button></t-col
          ><t-col :span="8" class="col_common_center">
            <!-- 削除 -->
            <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClick"
            >
              <i class="el-icon-delete"></i>
              {{ $t("resource.sys.delete") }}
            </t-button></t-col
          ><t-col :span="8" class="col_common_center">
            <!-- 出力 -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="outPutBtn"
              @click="outPutClick"
            >
              <i class="el-icon-download"></i>
              {{ $t("resource.NUMBER.OUTPUT_NUMBER") }}
            </t-button>
          </t-col>
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="$t('widgetSize.COMMON_WIDTH.EIGHTY_PX')"
            >
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="12">
                  <div>
                    <!-- 見積日 -->
                    <t-form-item :label="$t('resource.NUMBER.QUOTE_DATE')">
                      <t-date-picker
                        v-model="dateRange"
                        type="daterange"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy-MM-dd"
                        style="margin-top: 8px"
                        :clearable="false"
                        class="date_icon_center"
                        format="yyyy/MM/dd"
                        :editable="false"
                      >
                      </t-date-picker>
                    </t-form-item>
                  </div>
                </t-col>
                <t-col :span="5">
                  <!-- 見積状態 -->
                  <t-form-item :label="$t('resource.NUMBER.QUOTE_STATE')">
                    <t-select
                      v-model="searchConditionForm.nbQuoteState"
                      clearable
                      style="width: 100%"
                      :placeholder="$t('resource.sys.hidden')"
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="1" class="col_common_left">&nbsp;</t-col>
                <!-- 受注 -->
                <t-col :span="2" class="col_common_center">
                  <t-checkbox
                    v-model="searchConditionForm.orderChecked"
                    style="line-height: 3"
                    >{{ $t("resource.NUMBER.ORDER_STATE") }}</t-checkbox
                  >
                </t-col>
                <t-col :span="3">&nbsp;</t-col>
              </t-row>
              <t-row>
                <t-col :offset="1" :span="17" class="col_block_left">
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      v-model="searchConditionForm.searchWord"
                      class="input_searchKey"
                      maxLength="50"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <t-col :offset="1" :span="5" class="col_common_left">
                  <!-- 検索 -->
                  <t-button
                    round
                    type="primary"
                    class="button_common_search"
                    ref="searchBtn"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>
              </t-row>
            </t-form>
          </div>
        </div>
      </div>

      <div class="div_content">
        <t-table
          ref="numberTableData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="detailClick"
          :height="maxheight"
          border
        >
          <t-table-column type="selection" class-name="cell_txt_center" />
          <!-- 見積状態 -->
          <t-table-column
            prop="nbQuoteState"
            :label="$t('resource.NUMBER.QUOTE_STATE')"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.NUMBER.QUOTE_STATE'),
                'nbQuoteState'
              )
            "
            class-name="cell_txt_center"
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span :class="formatStatusColor(row)" class="status">●</span>
                <span class="quote-state">{{ row.nbQuoteState }} </span>
              </div>
            </template>
          </t-table-column>

          <!-- 受注 -->
          <t-table-column
            prop="nbOrderState"
            :label="$t('resource.NUMBER.ORDER_STATE')"
            class-name="cell_txt_center"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.NUMBER.ORDER_STATE'),
                'nbOrderState'
              )
            "
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span
                  v-if="row.nbOrderState === nbOrderStateOrdered"
                  class="status orderCheck"
                  >●</span
                >
              </div>
            </template>
          </t-table-column>

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
          </t-table-column>
        </t-table>
        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="numberTableDataLength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { getUserInfo } from "@/auth";
import { ShowNumberEditSupplierDialog } from "@/components/Dialog";
import { t } from "@/locales";
import { outputExcelToZip } from "@/services/common";
import {
  deleteNumberBasicInfo,
  getNumberBasicInfo,
  initNumberSearchList,
} from "@/services/number";
import {
  formatDateStrToString,
  formatDateToString,
  formatStringToCurrency,
  getPreviousMonthDate,
} from "@/utils/comFunction";
import { GetPageDataCount, NB_ORDER_STATE_ORDERED } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";

export default {
  data() {
    return {
      dateRange: [],

      searchConditionForm: {
        startQuoteDate: "",
        endQuoteDate: "",
        nbQuoteState: "",
        orderChecked: false,
        searchWord: "",
      },

      //一覧表のデータ
      numberTableData: [],
      //担当者
      userList: [],
      //見積状態
      statusList: [],

      columns: [
        // 見積日
        {
          prop: "nbQuoteDate",
          label: t("resource.NUMBER.QUOTE_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        // 見積No
        {
          prop: "nbQuoteNo",
          label: t("resource.NUMBER.QUOTE_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
        },
        // 得意先
        {
          prop: "nbCusCode",
          label: t("resource.NUMBER.CUSTOMER"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 得意先担当者
        {
          prop: "nbCusUserCode",
          label: t("resource.NUMBER.CUS_USER"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 担当者
        {
          prop: "nbUserCode",
          label: t("resource.NUMBER.CONTACTER"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 仕入金額(円）
        {
          prop: "nbPurchaseAmount",
          label: t("resource.NUMBER.PURCHASE_AMOUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
        // 売上金額(円）
        {
          prop: "nbSalesAmount",
          label: t("resource.NUMBER.SALES_AMOUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
        // 粗利金額(円)
        {
          prop: "nbGrossProfitAmount",
          label: t("resource.NUMBER.GROSS_PROFIT_AMOUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
      ],
      // 現在のページ数
      pageNo: 1,
      // データ個数/各ページ
      pageSize: 20,
      numberTableDataLength: 0,
      maxheight: window.innerHeight - 291.5 - 10, //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
      nbOrderStateOrdered: NB_ORDER_STATE_ORDERED,
      //カバー層のフラップ false:表示しない
      showFlag: false,
    };
  },

  mounted() {
    this.showFlag = true;

    //画面の初期化
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    setColumnWidth(this.columns, this.numberTableData);
  },

  computed: {
    tableData() {
      return this.numberTableData.slice(
        (this.pageNo - 1) * this.pageSize,
        this.pageNo * this.pageSize
      );
    },
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.maxheight = window.innerHeight - 291.5 - 10; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    },

    //状態背景色
    formatStatusColor(row) {
      return this.statusList.find((it) => it.label === row.nbQuoteState)
        ?.statusColor;
    },

    // 初期化
    init() {
      //見積日初期化
      this.dateInit();
      //検索条件リストの初期化(状態)
      initNumberSearchList()
        .then((res) => {
          this.$nextTick(() => {
            //見積状態
            this.statusList = res.searchStatus;
          });

          //検索処理
          this.searchClick();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        });
    },

    //見積日の初期化
    dateInit() {
      //システム日付
      var systemDate = new Date();

      //日付初期値の設定:見積日(開始～終了)
      this.dateRange = [getPreviousMonthDate(systemDate), systemDate];
    },

    // 検索
    searchClick() {
      //検索条件の調整
      this.updateSearchForm();

      //検索採番台帳基本情報
      getNumberBasicInfo(this.searchConditionForm)
        .then((res) => {
          this.numberTableData = res;

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));

          this.numberTableDataLength = res.length;
          // データ処理
          this.dataProcess();

          setColumnWidth(this.columns, this.numberTableData);
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
          // フォーカス削除
          this.$refs.searchBtn.$el.blur();
        });
    },

    //検索条件の調整
    updateSearchForm() {
      //見積日が空でない場合
      if (this.dateRange) {
        //見積日(開始)
        this.searchConditionForm.startQuoteDate = formatDateToString(
          this.dateRange[0]
        );

        //見積日(終了)
        this.searchConditionForm.endQuoteDate = formatDateToString(
          this.dateRange[1]
        );
      } else {
        this.searchConditionForm.startQuoteDate = "";
        this.searchConditionForm.endQuoteDate = "";
      }

      //スペースを削除
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();
    },

    //複数行データの削除
    deleteClick() {
      let data = this.$refs.numberTableData.selection;
      var deleteFlg = true;

      if (data.length >= 1) {
        let delList = [];
        for (let index = 0; index < data.length; index++) {
          var nbOrderState = this.tableData.find(
            (it) => it.nbQuoteNo === data[index].nbQuoteNo
          )?.nbOrderState;

          //受注済みのデータ、削除しない
          if (nbOrderState == NB_ORDER_STATE_ORDERED) {
            Modal.showError("", t("message.NUMBER.NOT_DELETE"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            deleteFlg = false;
            break;
          }

          delList.push(data[index].nbQuoteNo);
        }
        //削除可能の場合
        if (deleteFlg) {
          Modal.showWarning("", t("resource.sys.deleteMessage"), {
            $type: "prompt",
            confirmButtonText: t("resource.button.sure"),
            cancelButtonText: t("resource.button.cancel"),
            showCancelButton: true,
          }).then(() => {
            // 削除採番台帳基本情報
            deleteNumberBasicInfo({
              delList: delList,
              user: getUserInfo().UserId,
            })
              .then(() => {
                Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));
              })
              .catch((err) => {
                this.showFlag = false;
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
                }
              })
              .finally(() => {
                //検索処理を行う
                this.searchClick();
              });
          });
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
      // フォーカス削除
      this.$refs.delBtn.$el.blur();
    },
    // 新規
    addClick() {
      //新规
      ShowNumberEditSupplierDialog(
        { isAdd: true },
        t("resource.NUMBER.NUMBER_INFORMATION_DETAIL_VIEW"),
        (target) => {
          this.searchClick();
          //this.searchConditionForm.searchWord = target;
        }
      );
      // フォーカス削除
      this.$refs.addBtn.$el.blur();
    },

    //出力
    outPutClick() {
      this.showFlag = true;

      //検索条件の調整
      this.updateSearchForm();

      //採番台帳情報出力
      outputExcelToZip(
        httpApi.OutPutNumberExcel,
        this.searchConditionForm
      ).finally(() => {
        this.showFlag = false;
        // フォーカス削除
        this.$refs.outPutBtn.$el.blur();
      });
    },

    //詳細
    detailClick(row, column, cell, event) {
      //編集
      ShowNumberEditSupplierDialog(
        { isAdd: false, rowData: row },
        t("resource.NUMBER.NUMBER_INFORMATION_DETAIL_VIEW"),
        (target) => {
          this.showFlag = false;
          this.searchClick();
          //this.searchConditionForm.searchWord = target;
        }
      );
    },

    //データの処理
    dataProcess() {
      this.numberTableData.map((item) => {
        //見積状態の変換
        item.nbQuoteState = this.statusList.find(
          (it) => it.value === item.nbQuoteState
        )?.label;

        //見積日の変換
        item.nbQuoteDate = formatDateStrToString(item.nbQuoteDate);

        //得意先担当者
        item.nbCusUserCode = !item.nbCusUserCode
          ? ""
          : item.nbCusUserCode.split(":")[1];
        //担当者
        item.nbUserCode = !item.nbUserCode ? "" : item.nbUserCode.split(":")[1];

        //仕入金額、売上金額、粗利金額の変換
        item.nbPurchaseAmount = formatStringToCurrency(item.nbPurchaseAmount);
        item.nbSalesAmount = formatStringToCurrency(item.nbSalesAmount);
        item.nbGrossProfitAmount = formatStringToCurrency(
          item.nbGrossProfitAmount
        );

        return item;
      });
    },

    pageChange(val) {
      this.pageNo = val;
    },

    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },

    getPageDataCountFunc() {
      return GetPageDataCount();
    },

    //アダプティブ列幅
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.numberTableData);
    },
  },
};
</script>
<style lang="scss" scope>
.quote-state {
  flex: 1; /* 残りのスペースを2番目のspan要素に占有させ、コンテンツの配置を実現 */
}
</style>
